module.exports = __webpack_public_path__ + "static/media/24UHCHR16.ff984b7e.jpg";